import { apiClient } from './ApiClient';
import { API_ENDPOINTS } from '../../shared/constants';
import { ApiResponse, ReceiptApiData, TransactionApiData } from '../../shared/types';

export class TransactionApi {
    static async fetchBySupplierId(supplierId: number, token: string): Promise<TransactionApiData[]> {
        try {
            const response = await apiClient.get<ApiResponse<TransactionApiData[]>>(
                API_ENDPOINTS.transactions(supplierId),
                token
            );

            if (!response.success || !response.data) {
                return [];
            }

            return response.data;
        } catch (error) {
            console.error('Error fetching transactions:', error);
            return [];
        }
    }

    static async fetchReceipt(supplierId: number, transactionId: number, token: string): Promise<ReceiptApiData> {
        const response = await apiClient.get<ApiResponse<ReceiptApiData>>(
            API_ENDPOINTS.receipt(supplierId, transactionId),
            token
        );

        if (!response.success || !response.data) {
            throw new Error(response.message || 'Comprovante não encontrado');
        }

        return response.data;
    }
}
